import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import security from 'stores/security';

class Logout extends Component {
    public componentDidMount() {
        security.logout();
    }

    public render() {
        return <Redirect to="/" />;
    }
}

export default Logout;
